import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash-es';

import { messages } from './messages';
import { BulkActionDataType } from '../../enums/bulk-action-data-type';
import { silentRequestGetShipments } from '../../store/shipments/shipments.actions';

const getFulfillmentPlanCount = (job) => get(job, 'jobData.fulfillmentPlanCount', 0);

export const batchDetailsFull = {
  getBulkApplyMessageCount: getFulfillmentPlanCount,

  bulkApplyMessage: (count) => (
    <FormattedMessage
      {...messages.bulkApplyMessageBatchDetailsFull}
      values={{
        numberOfShipments: count,
        boldCount: <b>{count}</b>,
      }}
    />
  ),

  requestFilter: (fulfillmentPlanSetIds) =>
    fulfillmentPlanSetIds.map((fulfillmentPlanSetId) => ({
      fulfillmentPlanSetId,
    })),

  id: BulkActionDataType.BATCH_DETAILS_FULL,

  startUpdateNotificationContent: (job) => {
    const numberOfShipments = getFulfillmentPlanCount(job);
    return (
      <FormattedMessage
        {...messages.batchDetailsFull}
        values={{
          numberOfShipments,
        }}
      />
    );
  },

  updateSuccessNotificationContent: (job) => {
    const numberOfShipments = getFulfillmentPlanCount(job);
    return (
      <FormattedMessage
        {...messages.batchDetailsFullSuccess}
        values={{
          numberOfShipments,
        }}
      />
    );
  },

  updateSuccessActions: () => [silentRequestGetShipments()],
};
